import React from "react"
import SectionHeader from "./section-header"
import star from "../../images/solutions/why-sell-side/star.svg"

const Card = ({ heading, items = [], showStar, fullWidth = false }) => (
  <div
    className={`why-card background-blue-light p-6 is-flex is-flex-direction-column is-relative ${
      fullWidth ? "why-card--full" : ""
    }`}
    style={{
      borderRadius: 40,
      height: "100%",
    }}
  >
    {showStar && (
      <img
        src={star}
        alt="Highlight"
        className="why-card__star"
        style={{
          position: "absolute",
          top: "-12px",
          right: "40px",
          width: 25,
          height: 25,
        }}
      />
    )}
    <div
      className="why-card__heading has-text-left has-text-weight-bold is-size-4 text-dark-blue mb-5"
      style={{ whiteSpace: "nowrap" }}
    >
      {heading}
    </div>

    {items.map(({ title, icon }, i) => (
      <div
        key={i}
        className={`is-flex is-align-items-center ${
          i < items.length - 1 ? "mb-2" : ""
        }`}
      >
        <img src={icon} alt="" className="why-card__icon mr-3" />
        <span className="why-card__item text-dark-blue is-size-5 has-text-weight-semibold">
          {title}
        </span>
      </div>
    ))}
  </div>
)

const CenterResult = ({ lines = [], fullWidth = false }) => (
  <div
    className={`why-result background-blue-light p-6 is-flex is-justify-content-center is-align-items-center ${
      fullWidth ? "why-result--full" : ""
    }`}
    style={{ borderRadius: 40, height: "100%" }}
  >
    <div className="has-text-centered">
      {lines.map((line, i) => (
        <div key={i} className="is-size-3 has-text-weight-bold text-dark-blue">
          {line}
        </div>
      ))}
    </div>
  </div>
)

const Operator = ({ symbol }) => (
  <div className="why-op is-flex is-justify-content-center is-align-items-center">
    <div className="is-size-1 has-text-weight-bold text-dark-blue">
      {symbol}
    </div>
  </div>
)

const WhySellSide = ({
  title = "Why Sell-Side AI",
  leftTitle,
  leftItems,
  rightTitle,
  rightItems,
  centerResultLines = ["Maximum", "Impact"],
  description,
}) => (
  <section className="py-5 why-sell-side-section">
    <div
      className="container"
      style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
    >
      <SectionHeader title={title} />

      {/* Tablet + Desktop */}
      <div className="is-hidden-mobile why-sell-cards">
        <Card heading={leftTitle} items={leftItems} />
        <Operator symbol="+" />
        <Card heading={rightTitle} items={rightItems} showStar />
        <Operator symbol="=" />
        <CenterResult lines={centerResultLines} />
      </div>

      {/* Mobile */}
      <div
        className="is-hidden-tablet"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          marginTop: "2rem",
        }}
      >
        <Card heading={leftTitle} items={leftItems} fullWidth />
        <Operator symbol="+" />
        <Card heading={rightTitle} items={rightItems} showStar fullWidth />
        <Operator symbol="=" />
        <CenterResult lines={centerResultLines} fullWidth />
      </div>

      {description && (
        <div className="columns is-centered mt-6">
          <div className="column is-10-desktop is-9-tablet is-11-mobile">
            <p className="has-text-centered has-text-left-mobile text-dark-blue is-size-5-desktop">
              {description}
            </p>
          </div>
        </div>
      )}
    </div>
  </section>
)

export default WhySellSide
